(function () {
  'use strict';

  const SCROLL_PERCENTAGE = 0.15;

  function init() {
    const container = document.getElementById('fixedCtaContainer');

    if (!container) {
      return;
    }

    const currentLanguage = container.dataset.language || 'en';

    function calculateScrollThreshold() {
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      return documentHeight * SCROLL_PERCENTAGE;
    }

    function handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const threshold = calculateScrollThreshold();

      if (scrollY >= threshold) {
        container.classList.add('show');
      } else {
        container.classList.remove('show');
      }
    }

    if (currentLanguage) {
      container.classList.add('lang-' + currentLanguage);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    handleScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
